import { ContentWithImage } from "./ContentWithImage";
import type { ContentWithImageProps } from "./ContentWithImage.d";

export { ContentWithImage };
export type { ContentWithImageProps };
